import { useState, useRef } from "react";
import { Api } from "../Service/api";
import { useLocation } from "react-router-dom";
import { Button } from "../Common/Button";

const ImageUpload = () => {
    const [image, setImage] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const editorRef = useRef(null);
    const location = useLocation();
    const [locationData, setLocationData] = useState(location);
    const [imageUploadLoader, setImageUploadLoader] = useState(false);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setSelectedFile(file);
        }
    };

    const handleResetImage = () => {
        setImage(null);
        setSelectedFile(null);
    };

    const handleChooseFileClick = () => {
        document.getElementById("fileUpload").click();
    };

    const handleSubmit = async () => {
        if (!selectedFile) {
            alert("Please select a file first");
            return;
        }

        setImageUploadLoader(true);

        const formData = new FormData();
        formData.append("image", selectedFile);

        try {
            const responseimg = await Api.ImageUpload(formData);

            const fileUrl = responseimg?.data;

            if (fileUrl) {
                const funcNum = getUrlParam("CKEditorFuncNum");

                if (window.opener && window.opener.CKEDITOR) {
                    window.opener.CKEDITOR.tools.callFunction(funcNum, fileUrl);
                    window.close();
                } else {
                    alert("Image uploaded but editor not found");
                }
            } else {
                alert("Upload failed");
            }
        } catch (error) {
            console.error("Upload error", error);
            alert("Upload failed");
        } finally {
            setImageUploadLoader(false);
        }
    };


    function getUrlParam(paramName) {
        var reParam = new RegExp("(?:[?&]|&)" + paramName + "=([^&]+)", "i");
        var match = window.location.search.match(reParam);
        return match && match.length > 1 ? match[1] : null;
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-700 flex items-center justify-center p-10 font-poppins">
            <div className="w-full max-w-6xl bg-white shadow-2xl rounded-2xl p-10 grid grid-cols-1 lg:grid-cols-2 gap-10">


                {/* Upload Section */}
                <div className="space-y-6">
                    <h2 className="text-2xl font-bold text-gray-800">Upload Your Image</h2>
                    <p className="text-gray-600">Choose a file from your device to preview and submit.</p>


                    <div>
                        <label htmlFor="fileUpload" className="block text-sm font-medium text-gray-700 mb-2">Select File</label>
                        <input type="file" id="fileUpload" accept="image/*" className="hidden" onChange={handleImageChange} />


                        <button onClick={handleChooseFileClick}
                            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-md transition-transform hover:scale-105">
                            Browse
                        </button>
                        {selectedFile && (
                            <span className="ml-3 text-gray-700 font-medium">{selectedFile.name}</span>
                        )}
                    </div>


                    <div className="pt-4">
                        <button
                            disabled={!selectedFile || imageUploadLoader}
                            onClick={selectedFile ? handleSubmit : undefined}
                            className="w-full py-3 text-white font-semibold rounded-lg shadow-md bg-green-600 hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-transform hover:scale-105">
                            {imageUploadLoader ? "Uploading..." : "Submit"}
                        </button>
                    </div>
                </div>


                {/* Preview Section */}
                <div className="flex items-center justify-center">
                    {image ? (
                        <img src={URL.createObjectURL(image)} alt="Preview" className="rounded-xl shadow-lg max-h-96 object-contain border border-gray-200" />
                    ) : (
                        <div className="w-full h-80 border-2 border-dashed border-gray-300 rounded-xl flex items-center justify-center text-gray-500 text-center p-4">
                            No image selected
                        </div>
                    )}
                </div>


            </div>
        </div>
    );
};

export default ImageUpload;
